import React, { useEffect, useRef, useState } from "react";
import subscribe from "../../assets/subscribe.png";
import robot from "../../assets/robot.png";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { toast } from "react-toastify";
import api from "../../utilis/api";

gsap.registerPlugin(ScrollTrigger);

const Subscribe = () => {
  const [email, setEmail] = useState("");
  const leftRef = useRef(null);
  const rightRef = useRef(null);
  const inputRef = useRef(null);
  const infoRef = useRef(null);
  const checkboxRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    // Left text section
    gsap.from(leftRef.current, {
      x: -100,
      opacity: 0,
      duration: 1,
      ease: "power3.out",
      scrollTrigger: {
        trigger: leftRef.current,
        start: "top 80%",
        toggleActions: "play none none reverse",
      },
    });

    // Right section (entire container)
    gsap.from(rightRef.current, {
      x: 100,
      opacity: 0,
      duration: 1,
      ease: "power3.out",
      scrollTrigger: {
        trigger: rightRef.current,
        start: "top 80%",
        toggleActions: "play none none reverse",
      },
    });

    // Input + Subscribe Button
    gsap.from(inputRef.current, {
      y: 30,
      opacity: 0,
      duration: 0.8,
      ease: "power3.out",
      scrollTrigger: {
        trigger: inputRef.current,
        start: "top 90%",
        toggleActions: "play none none reverse",
      },
    });

    // Info Text
    gsap.from(infoRef.current, {
      y: 30,
      opacity: 0,
      duration: 0.8,
      delay: 0.1,
      ease: "power3.out",
      scrollTrigger: {
        trigger: infoRef.current,
        start: "top 90%",
        toggleActions: "play none none reverse",
      },
    });

    // Checkbox + Robot Image
    gsap.from(checkboxRef.current, {
      y: 30,
      opacity: 0,
      duration: 0.8,
      delay: 0.2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: checkboxRef.current,
        start: "top 90%",
        toggleActions: "play none none reverse",
      },
    });

    // Subscribe button scale animation
    gsap.from(buttonRef.current, {
      scale: 0.8,
      opacity: 0,
      duration: 0.8,
      ease: "back.out(1.7)",
      scrollTrigger: {
        trigger: buttonRef.current,
        start: "top 90%",
        toggleActions: "play none none reverse",
      },
    });
  }, []);

  const handleSubscribe = async () => {
    try {
      const response = await api.post("/subscribe", { email });

      if (response) {
        toast.success("Subscribed Successfully"); // typo fixed
        setEmail("");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error(error);
    }
  };
  return (
    <div
      className="banner-start py-[4rem]  bg-cover bg-center bg-no-repeat flex justify-center items-center text-white px-4 overflow-x-hidden"
      style={{ backgroundImage: `url(${subscribe})` }}
    >
      <div className="flex flex-col lg:flex-row justify-center items-start lg:items-center gap-8 w-full max-w-6xl">
        {/* Left Text Section */}
        <div
          ref={leftRef}
          className="flex flex-col gap-4 items-center lg:items-end text-center lg:text-right w-full lg:w-1/2"
        >
          <h1 className="font-Syne text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold">
            Subscribe To Our Newsletter
          </h1>
          <p className="font-Outfit text-[16px] sm:text-[18px] md:text-[20px] font-light">
            Stay tuned for discounts & stories
          </p>
        </div>

        {/* Right Input Section */}
        <div
          ref={rightRef}
          className="flex flex-col gap-4 items-center lg:items-start w-full lg:w-1/2"
        >
          {/* Email Input & Subscribe Button */}
          <div
            ref={inputRef}
            className="flex flex-col sm:flex-row gap-2 w-full max-w-md"
          >
            <input
              type="text"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 px-4 py-2 text-[16px] sm:text-[18px] outline-none text-black rounded-lg"
            />
            <button
              ref={buttonRef}
              onClick={handleSubscribe}
              className="px-6 py-2 text-[16px] sm:text-[18px] font-Syne font-bold gradient text-black rounded-lg w-full sm:w-auto"
            >
              Subscribe
            </button>
          </div>
          <div
            ref={checkboxRef}
            className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-6 w-full max-w-xs px-2 py-2 bg-white rounded-lg"
          >
            <div className="flex items-center gap-2 sm:gap-3">
              <input
                type="checkbox"
                id="terms"
                className="w-5 h-5 accent-blue-500 cursor-pointer"
              />
              <label
                htmlFor="terms"
                className="text-black font-Outfit text-[14px] sm:text-[16px] cursor-pointer"
              >
                I’m not a robot
              </label>
            </div>
            <img src={robot} alt="robot" className="w-6 h-6 sm:w-8 sm:h-8" />
          </div>
          {/* Info Text */}
          <p
            ref={infoRef}
            className="font-Outfit text-[14px] sm:text-[16px] md:text-[18px] font-light text-center lg:text-left"
          >
            We respect your privacy, so we never share your info.
          </p>

          {/* Checkbox Section */}
        </div>
      </div>
    </div>
  );
};

export default Subscribe;
